import { call } from '@advanza/api'

export interface SearchEngineIndex {
    label: string
    /** Resolves to the indexed document(s); null or an empty list means the provider isn't indexed. */
    fetchDocuments: (providerId: number) => Promise<unknown>
}

export const SEARCH_ENGINE_INDEXES: SearchEngineIndex[] = [
    {
        label: 'Providers index',
        fetchDocuments: (providerId) =>
            call(`office/providers/get-search-engine-provider/${providerId}`).then(
                (response: { document: unknown }) => response.document,
            ),
    },
    {
        label: 'Subscriptions index',
        fetchDocuments: (providerId) =>
            call(`office/providers/get-search-engine-subscriptions/${providerId}`).then(
                (response: { documents: unknown[] }) => response.documents,
            ),
    },
]

export const reindexProvider = (providerId: number): Promise<unknown> =>
    call(`office/providers/reindex-search-engine-provider/${providerId}`, { method: 'POST' })

/** call() rejects with the error payload, a status text, or an Error, depending on what failed. */
export function getSearchEngineErrorMessage(error: unknown): string {
    if (typeof error === 'string' && error !== '') {
        return error
    }
    if (error instanceof Error) {
        return error.message
    }
    if (typeof error === 'object' && error !== null && 'error' in error) {
        return String(error.error)
    }
    return 'The search engine request failed'
}
